<script>
import options from "./NykDateTimePicker.options"
export default options
</script>

<template>
  <div class="nyk-input">
    <div class="nyk-form" :class="{ 'nyk-form--validation-failed': errorMessage }">
      <div class="nyk-form__content">
        <input :ref="el => inputElement = el"
          :id="name"
          :name="name"
          type="text"
          class="nyk-form__content__input"
          :aria-describedby="errorMessage ? `description-${name}-error` : `description-${name}`"
          :aria-invalid="!!errorMessage"
          :aria-required="required"
          :invalid="!!errorMessage"
          :autocomplete="autoComplete"
          :max="maxDate"
          :min="minDate"
          :maxlength="maxLength"
          :placeholder="label"
          :value="value"
          v-bind="attributes"
          v-on="validationListeners"
          @input.prevent.stop="onInputChange"
          @select.prevent.stop
          @focus="onFocus"
          @blur.prevent.stop="onBlur"
          @keydown="onKeyDown">
        <label :for="name" class="nyk-form__content__label">{{ label }}</label>
        <button @click="resetInputValue" type="button" class="nyk-form__content__reset-icon nyk-form-js--reset" aria-label="reset input value">
          <span class="nyk-icon nyk-icon--ui-close"></span>
        </button>
        <div v-if="errorMessage" class="nyk-form__content__error-icon">
            <span class="nyk-icon nyk-icon--ui-form-error"></span>
        </div>
      </div>
      <span class="nyk-form__help-message" :id="`description-${name}`">{{ description }}</span>
      <span v-if="errorMessage" class="nyk-form__error-message" :id="`description-${name}-error`" aria-live="polite">{{ errorMessage }}</span>
    </div>
  </div>
</template>